import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import {
    EcosystemProvider,
    EcosystemRouter,
} from '@/shared/contexts/EcosystemContext';
import { AuthProvider } from '@/shared/contexts/AuthContext';
import { MembershipProvider } from '@/shared/contexts/MembershipContext';
import { ChatPageProvider } from '@/shared/contexts/ChatPageContext';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';
import './assets/scss/custom.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <HelmetProvider>
            <EcosystemProvider>
                <EcosystemRouter>
                    <AuthProvider>
                        <MembershipProvider>
                            <ChatPageProvider>
                                <App />
                            </ChatPageProvider>
                        </MembershipProvider>
                    </AuthProvider>
                </EcosystemRouter>
            </EcosystemProvider>
        </HelmetProvider>
    </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
